import { Box } from '@/components/Box/Box';
import { Loader } from '@/components/Loader/Loader';
import { AttemptsCount, Message } from '../styles';
import { useTranslation } from 'react-i18next';

interface CheckPinCodeMessageBoxType {
  attemptsCount: number;
  error: string;
  isLoading: boolean;
}

export const CheckPinCodeHintBox = ({ attemptsCount, error, isLoading }: CheckPinCodeMessageBoxType) => {
  const { t } = useTranslation('login');

  if (isLoading) {
    return (
      <Box marginTop='16px'>
        <Loader size='small' backgroundColor='transparent' />
      </Box>
    );
  }

  return (
    <>
      {attemptsCount && (
        <Box marginTop='16px' columnGap='5px' justifyContent='center' flexDirection='row'>
          {error && <Message hasError={!!error}>{error}</Message>}
          <AttemptsCount hasError={error}>{attemptsCount}</AttemptsCount>
          <Message hasError={!!error}>{t('login:attemptsLeftMessage')}</Message>
        </Box>
      )}
    </>
  );
};
